import { FolderInput } from 'lucide-react';
import {
  FloatingActionBar as SharedFloatingActionBar,
  FloatingActionButton,
  FloatingDeleteButton,
} from '@/components';

interface FloatingActionBarProps {
  /** Number of currently selected items. Bar is hidden when 0. */
  selectedCount: number;
  isBulkMoving: boolean;
  isBulkDeleting: boolean;
  onMoveClick: () => void;
  onDeleteClick: () => void;
}

/**
 * Sticky bar that appears at the bottom of the document list when one or more
 * rows are selected. Provides bulk "Move to" and "Delete" actions.
 */
export function FloatingActionBar({
  selectedCount,
  isBulkMoving,
  isBulkDeleting,
  onMoveClick,
  onDeleteClick,
}: FloatingActionBarProps) {
  const isBusy = isBulkMoving || isBulkDeleting;

  return (
    <SharedFloatingActionBar
      selectedCount={selectedCount}
      itemLabelKey="documents.multiselect.selectedCount"
    >
      <FloatingActionButton
        onClick={onMoveClick}
        icon={<FolderInput className="size-4" aria-hidden="true" />}
        labelKey="documents.multiselect.moveTo"
        isLoading={isBulkMoving}
        disabled={isBusy}
      />

      <FloatingDeleteButton
        onDelete={onDeleteClick}
        labelKey="documents.multiselect.delete"
        isDeleting={isBulkDeleting}
        disabled={isBusy}
        showConfirmation={false}
      />
    </SharedFloatingActionBar>
  );
}
